export const backgroundList = [
    // === SOLID COLORS ===
    //Graphite Grey
    "#2B2F36",
    //Obsidian Black
    "#0B0C0E",
    //Deep Navy
    "#0D1B2A",
    //Charcoal Teal
    "#12343B",
    //Midnight Green
    "#0F3D3E",
    //Iron Blue
    "#1F364D",
    //Onyx Violet
    "#2A2238",
    //Smoke Brown
    "#2E2420",
    //Deep Burgundy
    "#4A0E1B",
    //Metallic Bronze
    "#3B2F2A",

    // === LINEAR GRADIENTS (20) ===
    // Graphite Grey variants
    "linear-gradient(135deg,#2B2F36 0%,#3A4048 100%)",
    "linear-gradient(200deg,#242830 0%,#2B2F36 60%,#3E4450 100%)",

    // Obsidian Black variants
    "linear-gradient(145deg,#0B0C0E 0%,#17191D 100%)",
    "linear-gradient(180deg,#07080A 0%,#0B0C0E 50%,#1A1C21 100%)",

    // Deep Navy variants
    "linear-gradient(130deg,#0D1B2A 0%,#13263B 100%)",
    "linear-gradient(210deg,#0B1723 0%,#0D1B2A 55%,#1A2E45 100%)",

    // Charcoal Teal variants
    "linear-gradient(140deg,#12343B 0%,#1A4A52 100%)",
    "linear-gradient(200deg,#0E2A2F 0%,#12343B 60%,#205B65 100%)",

    // Midnight Green variants
    "linear-gradient(150deg,#0F3D3E 0%,#1A5A5C 100%)",
    "linear-gradient(195deg,#0C3233 0%,#0F3D3E 55%,#216F72 100%)",

    // Iron Blue variants
    "linear-gradient(135deg,#1F364D 0%,#2E4E6C 100%)",
    "linear-gradient(220deg,#192C3E 0%,#1F364D 55%,#3A6287 100%)",

    // Onyx Violet variants
    "linear-gradient(135deg,#2A2238 0%,#3B2E52 100%)",
    "linear-gradient(205deg,#211B2B 0%,#2A2238 55%,#4A3B6A 100%)",

    // Smoke Brown variants
    "linear-gradient(145deg,#2E2420 0%,#45352E 100%)",
    "linear-gradient(190deg,#241B18 0%,#2E2420 55%,#5A463C 100%)",

    // Deep Burgundy variants
    "linear-gradient(140deg,#4A0E1B 0%,#6A1A2B 100%)",
    "linear-gradient(215deg,#3A0B15 0%,#4A0E1B 55%,#84233A 100%)",

    // Metallic Bronze variants
    "linear-gradient(135deg,#3B2F2A 0%,#55463D 100%)",
    "linear-gradient(185deg,#2F2622 0%,#3B2F2A 55%,#6A5A4F 100%)",

    // === RADIAL GRADIENTS (20) ===
    // Graphite Grey
    "radial-gradient(circle at 40% 35%,#3A4048 0%,#2B2F36 60%,#232730 100%)",
    "radial-gradient(circle at 70% 60%,#3E4450 0%,#2B2F36 55%,#1F232C 100%)",

    // Obsidian Black
    "radial-gradient(circle at 30% 70%,#1A1C21 0%,#0B0C0E 60%,#07080A 100%)",
    "radial-gradient(circle at 60% 30%,#17191D 0%,#0B0C0E 55%,#060708 100%)",

    // Deep Navy
    "radial-gradient(circle at 45% 40%,#13263B 0%,#0D1B2A 60%,#0A1520 100%)",
    "radial-gradient(circle at 75% 65%,#1A2E45 0%,#0D1B2A 55%,#09121B 100%)",

    // Charcoal Teal
    "radial-gradient(circle at 35% 35%,#1A4A52 0%,#12343B 60%,#0D2429 100%)",
    "radial-gradient(circle at 70% 60%,#205B65 0%,#12343B 55%,#0B1F23 100%)",

    // Midnight Green
    "radial-gradient(circle at 40% 30%,#1A5A5C 0%,#0F3D3E 60%,#0A2B2C 100%)",
    "radial-gradient(circle at 75% 65%,#216F72 0%,#0F3D3E 55%,#092426 100%)",

    // Iron Blue
    "radial-gradient(circle at 35% 35%,#2E4E6C 0%,#1F364D 60%,#162636 100%)",
    "radial-gradient(circle at 70% 60%,#3A6287 0%,#1F364D 55%,#12202D 100%)",

    // Onyx Violet
    "radial-gradient(circle at 40% 30%,#3B2E52 0%,#2A2238 60%,#1C1626 100%)",
    "radial-gradient(circle at 75% 65%,#4A3B6A 0%,#2A2238 55%,#181222 100%)",

    // Smoke Brown
    "radial-gradient(circle at 35% 35%,#45352E 0%,#2E2420 60%,#201915 100%)",
    "radial-gradient(circle at 70% 60%,#5A463C 0%,#2E2420 55%,#1A1411 100%)",

    // Deep Burgundy
    "radial-gradient(circle at 40% 30%,#6A1A2B 0%,#4A0E1B 60%,#2E0810 100%)",
    "radial-gradient(circle at 75% 65%,#84233A 0%,#4A0E1B 55%,#25060C 100%)",

    // Metallic Bronze
    "radial-gradient(circle at 35% 35%,#55463D 0%,#3B2F2A 60%,#271F1B 100%)",
    "radial-gradient(circle at 70% 60%,#6A5A4F 0%,#3B2F2A 55%,#221B17 100%)"
];

export const accentColorList = [
    "#1FA39A",
    "#14B8A6",
    "#2DD4BF",
    "#22D3EE",
    "#38BDF8",
    "#2EA8FF",
    "#10B981",
    "#22C55E",
    "#8B5CF6",
    "#6366F1",
]
